export default __webpack_public_path__ + "static/media/Task_Line.a756b9b0.svg";